import { request, withQuery } from './client';
import type { CategoryRef, ProductCard, ProductCreate, ProductLastPurchaseResponse, ProductListResponse, ProductPatch, ProductStats } from '@kassa/shared';

export interface ProductListParams {
  q?: string;
  categoryId?: string;
  /** '1' — passivlər də (KT-99 status süzgəci). */
  includeInactive?: string;
  page?: number;
  limit?: number;
  /** Sıralama (KT-108): name, -name, price, -price, qty, -qty */
  sort?: string;
}

export const productsApi = {
  products: (p: ProductListParams) =>
    request<ProductListResponse>('GET', withQuery('/api/products', { ...p })),
  productStats: () => request<ProductStats>('GET', '/api/products/stats'),
  productCategories: () => request<CategoryRef[]>('GET', '/api/products/categories'),
  productCategoryCreate: (name: string) => request<CategoryRef>('POST', '/api/products/categories', { name }),
  productCategoryRename: (id: string, name: string) => request<CategoryRef>('PATCH', `/api/products/categories/${encodeURIComponent(id)}`, { name }),
  productCard: (id: string) => request<ProductCard>('GET', `/api/products/${encodeURIComponent(id)}`),
  productCreate: (body: ProductCreate) => request<{ id: string }>('POST', '/api/products', body),
  productLastPurchase: (id: string) => request<ProductLastPurchaseResponse>('GET', `/api/products/${encodeURIComponent(id)}/last-purchase`).then((r) => r.lastPurchase),
  productSetPrice: (id: string, retailPrice: number) => request<{ id: string }>('POST', `/api/products/${encodeURIComponent(id)}/price`, { retailPrice }),
  productPatch: (id: string, body: ProductPatch) =>
    request<{ id: string }>('PATCH', `/api/products/${encodeURIComponent(id)}`, body),
};
